/**
 * Created by Ning Jiang on 3/20/2017.
 */

import {SpinParsedGameData} from "@nolimitcity/slot-game/bin/game/reel/spinreel/SpinParsedServerData";
import {HorribleHeroesServerDataParser} from "../HorribleHeroesServerDataParser";
import {IHorribleHeroesGameData} from "./IHorribleHeroesServerData";
import {IBetLineWinData, IBetWayWinData} from "@nolimitcity/slot-game/bin/core/server/data/IServerData";

export class HorribleHeroesParsedGameData extends SpinParsedGameData {
    private readonly _betWinsWays: IBetLineWinData[] | IBetWayWinData[] | undefined;
    private readonly _betWinsBeforeXWays: IBetLineWinData[] | IBetWayWinData[] | undefined;
    private readonly XWaysExpand: boolean[];
    private readonly potentialSymbolPositions: boolean[][];
    private readonly expandedSymbol: string;
    private readonly scatterCount: number;
    private readonly totalNumberOfWays: number;
    private readonly numberOfWaysWon: number;
    private readonly accumulatedRoundWin: string;
    private readonly gameAreaSizeAfter: number[];
    private readonly infectiousSymOnReel: boolean[];
    private readonly gameAreaSizeXwaysExpand: number[];
    private readonly infectiousPos: number[][];
    private readonly symbolSizesPos: number[][];
    private readonly _nonInfectedPos: number[][];
    private readonly _nonInfectedXWaysPos: number[][];
    private readonly _mysteryPositions: number[][][];
    private readonly _mysteryXWaysPositions: number[][][];
    private readonly _bonusPositions: number[];
    private readonly _gameSizeEnteringFreespin: number[];
    private readonly _XWaysInfectiousTriggered: boolean;
    private readonly _xWaysSymbolMayGiveWin: boolean;
    private readonly _superFSTriggered: boolean;
    private readonly _superFSActivated: boolean;
    private readonly _fsCollectedScatters: number;
    private readonly _XSymbolPositions: number[];
    //Extra expand
    private readonly _numberOfExpandSymbolOnReel: number[];

    private readonly _freespinSpinChoices: number[];
    private readonly _randomWildFS: boolean[][];
    private readonly _evaluatedArea: string[][];
    private readonly _brokeTheBank: boolean;
    private readonly _lockedWildWindow: boolean[][];
    private readonly _lockedWildNextSpin: boolean[][];
    private readonly _wildMultipliers: number[][];
    private readonly _symbolSizes: number[][];
    //Expand X
    private readonly _mysterySymbolSizes: number[];

    constructor(rawData: IHorribleHeroesGameData, dataParser: HorribleHeroesServerDataParser) {
        super(rawData, dataParser);
        this._brokeTheBank = dataParser.parseBrokeTheBank(rawData);
        this._randomWildFS = dataParser.parseRandomWildFS(rawData);
        this._freespinSpinChoices = dataParser.parseFreespinSpinChoices(rawData);
        this._betWinsBeforeXWays = dataParser.parseBetWinsBeforeXways((rawData));
        this._betWinsWays = dataParser.parseBetWinsInit((rawData));
        this.potentialSymbolPositions = rawData.highlightPotentialWinSymbol;
        this.totalNumberOfWays = dataParser.parseTotalNumberOfWays(rawData);
        this.numberOfWaysWon = rawData.numberOfWaysWon;
        this.accumulatedRoundWin = rawData.accumulatedRoundWin;
        this._lockedWildWindow = dataParser.parseLockedWildWindow(rawData);
        this._lockedWildNextSpin = dataParser.parseLockedWildNextSpin(rawData);
        this._wildMultipliers = dataParser.parseWildMultipliers(rawData);
        this._bonusPositions = rawData.bonusPositions!;//positions where +freeanimation plays
        this._evaluatedArea = rawData.evaluatedArea!;
        this._superFSTriggered = dataParser.parseSuperFSTriggered(rawData);
        this._superFSActivated = rawData.superFSActivated;
        this._fsCollectedScatters = rawData.fsCollectedScatters;
        this.scatterCount = rawData.scatterCount;

        this.XWaysExpand = rawData.XWaysExpand;
        this._XSymbolPositions = rawData.XSymbolPositions;
        this.gameAreaSizeXwaysExpand = rawData.gameAreaSizeXwaysExpand;
        this.expandedSymbol = dataParser.parseExpandedSymbol(rawData);

        this._XWaysInfectiousTriggered = rawData.XWaysInfectiousTriggered;
        this._numberOfExpandSymbolOnReel = dataParser.parseNumberOfExpandedSymbol(rawData);
        this._symbolSizes = rawData.symbolSizes;
        this.symbolSizesPos = dataParser.parseSymbolSizesPos(rawData);
        this._mysteryPositions = dataParser.parseMysteryPositions(this.symbolSizesPos);
        this._mysteryXWaysPositions = dataParser.parseMysteryXwaysPositions(rawData);
        this._nonInfectedPos = dataParser.parseNonInfectedPos(this._mysteryPositions, rawData);
        this._nonInfectedXWaysPos = dataParser.parseXWaysNonExpandingPos(this._mysteryXWaysPositions, rawData);

        this.infectiousPos = dataParser.parseInfectiousPos();
        this._mysterySymbolSizes = dataParser.parseMysterSymSize();
        this.gameAreaSizeAfter = dataParser.parseGameAreaSizeAfter(rawData);

        this.infectiousSymOnReel = rawData.XWaysInfectious;
        this._gameSizeEnteringFreespin = rawData.gameSizeEnteringFreespin;//on restore on fSintro
        this._xWaysSymbolMayGiveWin = rawData.xWaySymbolMayGiveWin;
    }

    get lockedWildWindow(): boolean[][] {
        return this._lockedWildWindow;
    }

    get lockedWildNextSpin(): boolean[][] {
        return this._lockedWildNextSpin;
    }

    get wildMultipliers(): number[][] {
        return this._wildMultipliers;
    }

    public get symbolSizes(): number[][] {
        return this._symbolSizes;
    }

    get brokeTheBank(): boolean {
        return this._brokeTheBank;
    }

    get randomWildFS(): boolean[][] {
        return this._randomWildFS;
    }

    get freespinSpinChoices(): number[] {
        return this._freespinSpinChoices;
    }

    get superFSTriggered(): boolean {
        return this._superFSTriggered;
    }

    get isXWayExpanded(): boolean[] {
        return this.XWaysExpand;
    }

    get scatterCountValue(): number {
        return this.scatterCount;
    }

    get IsInfectiousSymOnReel(): boolean[] {
        return this.infectiousSymOnReel;
    }

    get getGameAreaSizeAfter(): number[] {
        return this.gameAreaSizeAfter;
    }

    get getGameSizeXwaysExpand(): number[] {
        return this.gameAreaSizeXwaysExpand;
    }

    get betWaysBeforeXWays(): IBetLineWinData[] | IBetWayWinData[] | undefined {
        return this._betWinsBeforeXWays
    }

    public get getPotentialSymbolPostions(): boolean[][] {
        return this.potentialSymbolPositions;
    }

    get getTotalNumOfWays(): number {
        return this.totalNumberOfWays;
    }

    get getNumberOfWaysWon(): number {
        return this.numberOfWaysWon;
    }

    public get bonusPositions(): number[] {
        return this._bonusPositions;
    }

    public get gameSizeEnteringFreespin(): number[] {
        return this._gameSizeEnteringFreespin;
    }

    public get mysterySymbolSizes(): number[] {
        return this._mysterySymbolSizes;
    }

    public get XSymbolPositions(): number[] {
        return this._XSymbolPositions;
    }

    //Expanded sym
    get getExpandedSymbol(): string {
        return this.expandedSymbol;
    }

    public get numberOfExpandSymbolOnReel(): number[] {
        return this._numberOfExpandSymbolOnReel;
    }

    public get XWaysInfectiousTriggered(): boolean {
        return this._XWaysInfectiousTriggered;
    }

    get getSymbolSizesPos(): number[][] {
        return this.symbolSizesPos;
    }

    get getInfectiousPos(): number[][] {
        return this.infectiousPos;
    }

    get getNonInfectedPos(): number[][] {
        return this._nonInfectedPos;
    }

    get getNonInfectedXWaysPos(): number[][] {
        return this._nonInfectedXWaysPos;
    }

    get getXWaySymbolMayGiveWin(): boolean {
        return this._xWaysSymbolMayGiveWin;
    }

    get isSuperActivatedSpin(): boolean {
        return this._superFSActivated;
    }

    public get getScattersCollected(): number {
        return this._fsCollectedScatters;
    }

    public getGameSizeWildMultipliers(): number {
        const wildReelSize = [4, 4, 4, 4, 4];
        let sum = 1;
        if (this.wildMultipliers) {
            this.wildMultipliers.forEach((eachReel, reelId) => {
                eachReel.forEach((symSize) => {
                    if (symSize > 1) {
                        wildReelSize[reelId] = wildReelSize[reelId] + (symSize - 1);

                    }
                });
                sum = sum * wildReelSize[reelId];
            });
        }
        return sum;
    }

    public getEvaluatedArea(): string[][] {
        return this._evaluatedArea;
    }

    protected isFreespin(rawData: IHorribleHeroesGameData): boolean {
        return (rawData.mode.indexOf("FREESPIN") > -1);
    }

    protected isNextFreespin(rawData: IHorribleHeroesGameData): boolean {
        return (rawData.nextMode.indexOf("FREESPIN") > -1);
    }
}